<template>
    <div v-show="content" class="event-desc">
        <div class="padding" v-html="icon">
        </div>
        <div class="content">
            {{ content }}
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        icon() {
            return `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8 12C8 11.1716 8.67157 10.5 9.5 10.5H27.5C28.3284 10.5 29 11.1716 29 12C29 12.8284 28.3284 13.5 27.5 13.5H9.5C8.67157 13.5 8 12.8284 8 12ZM8 24C8 23.1716 8.67157 22.5 9.5 22.5H18.5C19.3284 22.5 20 23.1716 20 24C20 24.8284 19.3284 25.5 18.5 25.5H9.5C8.67157 25.5 8 24.8284 8 24ZM9.5 16.5C8.67157 16.5 8 17.1716 8 18C8 18.8284 8.67157 19.5 9.5 19.5H27.5C28.3284 19.5 29 18.8284 29 18C29 17.1716 28.3284 16.5 27.5 16.5H9.5Z" fill="url(#paint0_radial_11692_140653)"/>
<defs>
<radialGradient id="paint0_radial_11692_140653" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(18.5 11.4783) rotate(90) scale(14.3478 16.7624)">
<stop stop-color="#FA604A"/>
<stop offset="1" stop-color="#9235A1"/>
</radialGradient>
</defs>
</svg>
`;
        }
    },
    props: {
        content: {
            type: String,
            required: false,
            default: ''
        }
    },
    name: "EventDescriptionPublic"
}
</script>

<style lang="scss" scoped>
.event-desc {
    background: #FFFFFF;
    box-shadow: 3px 6px 12px rgba(58, 1, 67, 0.05);
    border-radius: 16px;
    display: flex;
    align-items: center;
    padding: 12px;

    .padding {
        width: 56px;
        align-self: flex-start;
        line-height: 0;
        padding-right: 16px;
    }

    .content {
        white-space: pre-wrap;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        color: #24252A;
        word-break: break-word;
    }
}
</style>
